<template>
  <div>
    <NavBar></NavBar>
    <Breadcrumb></Breadcrumb>
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-3 mb-5">
          <SideBar></SideBar>
        </div>
        <div class="col-lg-9 content">
          <div class="pages">
             <div>
    <div v-if="pageDetailsList.data">
    <h1 class="main-title">{{ pageDetailsList.data.title }}</h1>
    <div
            :inner-html.prop="pageDetailsList.data.description.replace('/files/', 'https://cdn.tavguvenlik.com/files/')"
          ></div>
    </div>
  </div>
            <div>
           <!-- <div v-for="navItem in navItems" v-bind:key="navItem.slug">

                    <div v-if="navItem.slug == slug">
                      <h2>{{ navItem.subDynamicFields[0].slug }}</h2>

                    </div>
                    </div>-->

                 

               <!--<div
      class="container"
      v-for="catPageDetail of catPageDetails"
      v-bind:key="catPageDetail._id"
    >
      <div v-if="catPageDetail._id">
        <h2>{{ catPageDetail.title }}</h2>
        <div class="row align-items-center">
          <div class="col-md-3">
            <div class="media-container">
              <p v-html="catPageDetail.shortDescription"></p>
            </div>
          </div>
          <div
            class="col-md-9 body"
            :inner-html.prop="catPageDetail.description"
          ></div>
        </div>
      </div>
      </div>-->       
            </div>  
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import ContentService from '@/services/ContentService.js';

import NavBar from "@/components/shared/NavBar.vue";
import Breadcrumb from "@/components/shared/Breadcrumb.vue";
import SideBar from "@/components/shared/SideBar.vue";
import Footer from "@/components/shared/Footer.vue";
export default {
  data() {
    return {
      pageDetailsList : [],
      pageSlug: this.$route.params.slug
    };

  },
  props: {
    slug: {
      type: String,
      required: true,
    }
  },
  created() {
      ContentService.getPageDetail(this.$route.params.pageDetailSlug, this.$application, this.$t("languageCode"))
      .then((res) => (this.pageDetailsList = res.data))
      .catch((error) => console.log("There was an error:" + error));
       /*ContentService.getNavigation(this.$application, this.$t("languageCode"))
      .then((res) => (this.navItems = res.data.data.subDynamicFields))
      .catch((error) => console.log("There was an error:" + error));*/

     /* ContentService.getPageDetail('training-services', this.$application, this.$t("languageCode"))
      .then((res) => (this.pageDetailsList = res.data))
      .catch((error) => console.log("There was an error:" + error));*/
  },
  components: {
    NavBar,
    Breadcrumb,
    SideBar,
    Footer
  }, 
  computed: {
   /* formatSlug: function () {
      if (this.navItems.filter(navItem => navItem.slug == this.slug)) {
      return this.navItem.subDynamicFields[0].slug
      } else {
        return 'an error occured'
      }
  }*/
  }  
};
</script>

<style></style>
